const ALLOWED_DOMAINS = ["centivo.com"];

const ACTIONS = {
    CREATE: 'Create',
    AMEND: 'Amend'
}

const ALL_INSTRUCTIONS = [
    {
        step: 1,
        instructions: "Account, Product, Template, Plan name, HCCID, Desc",
        validation: ["asOfDate", "account", "product", "template", "benefitPlanName", "benefitPlanHccId", "benefitPlanDesc"],
    },
    {
        step: 2,
        instructions: "Coverage Tier and Dates",
        validation: ["coverageTeir", "effectiveStartDate"],
    },
    {
        step: 3,
        instructions: "Bank account, Value list, COB, Member UDT",
        //  validation: ["memberUdt", "bankAccount", "valueList"],
    },
    {
        step: 4,
        instructions: "Repricer and Network Definition",
        //    validation: ["repricer", "networks"],
    },
    {
        step: 5,
        instructions: "Non-Participating Pricing",
        //    validation: ["nonParticipatingPricingNoControl", "nonParticipatingPricingTrueOutOfNetwork"],
    },
    {
        step: 6,
        instructions: "Vendors",
        //    validation: ["vendors"],
    },
    {
        step: 7,
        instructions: "Medical Accumulator In-Network",
        //    validation: ["accumulator.medical.inNetwork"],
    },
    {
        step: 8,
        instructions: "Medical Accumulator  Out-of-Network",
        //    validation: ["accumulator.medical.outOfNetwork"],
    },
    {
        step: 9,
        instructions: "Prescription Accumulator In-Network ",
        //    validation: ["accumulator.prescription.inNetwork"],
    },
    {
        step: 10,
        instructions: "Prescription Accumulator Out-of-Network ",
        //    validation: ["accumulator.prescription.outOfNetwork"],
    },
    {
        step: 11,
        instructions: "Member Benefit Rules ",
        //    validation: ["rules"],
    },
    {
        step: 12,
        instructions: "Preventive Care",
        //    validation: ["costShareBenefitDetails.preventiveCare"],
    },
    {
        step: 13,
        instructions: "Physician Services",
        //     validation: ["costShareBenefitDetails.physicianServices"],
    },
    {
        step: 14,
        instructions: "Hospital / Other Services",
        //   validation: ["costShareBenefitDetails.hostpitalOtherServices"],
    },
    {
        step: 15,
        instructions: "Special Services",
        //     validation: ["costShareBenefitDetails.specialServices"],
    },
    {
        step: 16,
        instructions: "Exclusions and Limits",
        //     validation: ["exclusions", "limits"],
    },
    {
        step: 17,
        instructions: "Pre-certification Rules",
        //    validation: ["preCertRules"],
    },
    {
        step: 18,
        instructions: "Manually add riders",
        //    validation: ["extraRiders"],
    },
    {
        step: 19,
        instructions: "Review Value List",
    },
];

const SLOT_NAMES = {
    ALLERGY_SERVICES: 'Allergy Services',
    ALTERNATIVE_THERAPY: 'Alternative Therapy',
    CHIROPRACTIC: 'Chiropractic',
    REPRICER_PROVISION: 'Repricer Provision',
    THERAPY: 'Therapy',
    URGENT_CARE: 'Urgent Care',
    REPRODUCTIVE_SERVICES_INFERTILITY: 'Reproductive Services - Infertility',
    CELLULAR_GENE_THERAPY: 'Cellular Gene Therapy',
    PREVENTIVE_SERVICES: 'Preventive Services',
    AMBULANCE: 'Ambulance',
    HOME_HEALTH: 'Home Health',
    DIAGNOSTIC_TEST_RADIOLOGY: 'Diagnostic Test Radiology',
    COLONOSCOPY: 'Colonoscopy',
    DENTAL_ACCIDENTAL: 'Dental Accidental',
    DIAGNOSTIC_LAB: 'Diagnostic Lab',
    THERAPEUTIC_TREATMENT: 'Therapeutic Treatment',
    EMERGENCY_SERVICE: 'Emergency Service',
    INPATIENT: 'Inpatient',
    PHYSICIAN_SERVICES: 'Physician Services',
    TELEMEDICINE_TELEHEALTH: 'Telemedicine - Telehealth',
    TRANSPLANTS: 'Transplants',
    GENDER_AFFIRMATION: 'Gender Affirmation',
    SLEEP_STUDIES: 'Sleep Studies',
    VISION_SERVICES: 'Vision Services',
    HEARING_AIDS: 'Hearing Aids',
    BEHAVIORAL_HEALTH: 'Behavioral Health',
    GASTRIC_BYPASS_BARIATRIC: 'Gastric Bypass-Bariatric',
    SURGICAL_SERVICES: 'Surgical Services',
    ADVANCED_DIAGNOSTIC: 'Advanced Diagnostic',
    DME: 'DME',
    DIABETIC_SERVICES: 'Diabetic Services',
    GENETIC_TESTING: 'Genetic Testing',
    HOSPICE: 'Hospice',
    NUTRITIONAL_COUNSELING: 'Nutritional Counseling',

    COB_PROCESSING: 'COB Processing Provision',
    ER_NON_EMERGENT_PENALTY: 'ER Non Emergent Penalty',
    EXCLUSIONS: 'Exclusions',
    NETWORK_PRICING_DENY_BACK: 'Network Pricing - Deny Back',
    INVALID_MEMBER: 'Invalid Member Provision',
    BENEFIT_DETERMINATION: 'Benefit Determination',
    MEMBER_UDT: 'Member UDT',
    BANK_ACCOUNT: 'Bank Account',
    NON_PAR_PRICING: 'Non Par Pricing',
    DEFAULT_COMPONENT: 'Default Component',
    OOP_MAX_DEDUCTIBLE: 'OOP Max - Deductible',
    LIMITS: 'Limits',
    VENDOR_INVOICES: 'Vendor Invoices',

    SPRING_HEALTH: 'Vendor Spring Health',
    ASCENSION: 'Vendor Ascension',
    PROGYNY: 'Vendor Progyny',
    VIRTA: 'Vendor Virta',
    UPSWING_NETWORK: 'Upswing Network',

    RULES_PRECERT_CIGNA_OUTPATIENT: 'UM Rules - Precert - Cigna Outpatient',
    RULES_PRECERT_CIGNA_INPATIENT: 'UM Rules - Precert - Cigna Inpatient',
    RULES_PRECERT_ARCHIMEDES: 'UM Rules - Precert - Archimedes',
    RULES_NON_ELECTED_PCP: 'UM Rules - Non Elected PCP',
    RULES_PRECERT_CIGNA_BUY_UP: 'UM Rules - Precert - Cigna Buy Up',
    RULES_PRECERT_MEDWATCH: 'UM Rules - Precert - Medwatch',
    RULES_REFERRALS: 'UM Rules - Referrals',

}

const RIDER_COMPONENT_CATEGRIES = {
    PHYSICIAN_SERVICES: 'Benefits - Physician Services',
    BEHAVIORAL_HEALTH: 'Benefits - Behavioral Health',
    THERAPY_SERVICES: 'Benefits - Therapy Services',

    TELEMEDICINE: 'Benefits - Telemedicine',
    ALLERGY: 'Benefits - Allergy',
    NUTRITIONAL_COUNSELING: 'Benefits - Nutritional Counseling',
    REPRODUCTIVE_SERVICES: 'Benefits - Reproductive Services',
    DIABETIC_SERVICES: 'Benefits - Diabetic Services',
    COLONOSCOPY: 'Benefits - Colonoscopy',
    CELLULAR_GENE_THERAPY: 'Benefits - CGT',
    GENETIC_TESTING_COUNSELING: 'Benefits - Genetic T/C',
    SLEEP_STUDY: 'Benefits - Sleep Study',
    HEARING_AIDS: 'Benefits - Hearing Aids',
    VISION_SERVICES: 'Benefits - Vision Services',


    URGENT_CARE: 'Benefits - Urgent Care',
    ALTERNATIVE_SERVICES: 'Benefits - Alt Therapy',
    CHIROPRACTIC: 'Benefits - Chiropractic',
    DENTAL_ACCIDENT: 'Benefits - Dental Accident',
    TRANSPLANT_SERVICES: 'Benefits - Transplant Services',
    GENDER_AFFIRMATION: 'Benefits - Gender Affirmation',
    GASTRIC_BYPASS: 'Benefits - Gastric Bypass',
    INPATIENT: 'Benefits - Inpatient Services',
    EMERGENCY_ROOM: 'Benefits - Emergency Room',
    SURGICAL: 'Benefits - Surgical Services',
    LABS: 'Benefits - Lab Services',
    RADIOLOGY: 'Benefits - Radiology and Diagnostic',
    ADVANCED_DIAGNOSTICS: 'Benefits - ADV Diagnostic',
    THERAPEUTIC_TREATMENT: 'Benefits - Therapeutic Treatment',
    HOME_HEALTH: 'Benefits - Home Health/PDN',
    HOSPICE: 'Benefits - Hospice',
    DME: 'Benefits - DME',
    PREVENTIVE: 'Benefits - Preventive',
}

const TOP_ACCOUNT_BUILDER_INSTRUCTIONS = [
    {
        step: 1,
        instructions: "Top Account Overview",
    },
    {
        step: 2,
        instructions: "Top Account Contact Information",
    },
    {
        step: 3,
        instructions: "Top Account Billing Information",
    },
    {
        step: 4,
        instructions: "Sub Accounts",
    },
    {
        step: 5,
        instructions: "UDTs",
    },
    {
        step: 6,
        instructions: "Review and Submit",
    },
];

const SUB_ACCOUNT_BUILDER_INSTRUCTIONS = [
    {
        step: 1,
        instructions: "Sub Account Overview",
    },
    {
        step: 2,
        instructions: "Sub Account Contact Information",
    },
    {
        step: 3,
        instructions: "Sub Account Billing Information",
    },
    {
        step: 4,
        instructions: "Review and Submit",
    },
];

const SUB_ACCOUNT_DRAFT = 'subAccountDraft';

const USA_STATES = [
    { value: 'AL', label: 'Alabama' },
    { value: 'AK', label: 'Alaska' },
    { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' },
    { value: 'AS', label: 'American Samoa' },
    { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' },
    { value: 'DC', label: 'District of Columbia' },
    { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' },
    { value: 'GU', label: 'Guam' },
    { value: 'HI', label: 'Hawaii' },
    { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' },
    { value: 'IA', label: 'Iowa' },
    { value: 'KS', label: 'Kansas' },
    { value: 'KY', label: 'Kentucky' },
    { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' },
    { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' },
    { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' },
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' },
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' },
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'PR', label: 'Puerto Rico' },
    { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' },
    { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' },
    { value: 'UT', label: 'Utah' },
    { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' },
    { value: 'VI', label: 'Virgin Islands' },
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' },
];

export {
    ALLOWED_DOMAINS,
    ACTIONS,
    ALL_INSTRUCTIONS,
    RIDER_COMPONENT_CATEGRIES,
    SLOT_NAMES,
    TOP_ACCOUNT_BUILDER_INSTRUCTIONS,
    SUB_ACCOUNT_BUILDER_INSTRUCTIONS,
    SUB_ACCOUNT_DRAFT,
    USA_STATES
};
